module.exports = __webpack_public_path__ + "./docs/img/slots-icon-info.6d69cc8c85fea461bf41f5e01498b86d.svg";